import React, { Fragment, useState, useEffect } from 'react';
import Slider from 'react-slick';

import { EXCLUSIVE, ALL_ITEMS_LINK, STORES_LINK, SHARES } from './constants';

import './FooterToystory.scss';

export const FooterToystory = ({ baseImgUrl }) => {
  const [position, setPosition] = useState('fixed');

  const exclusiveSetting = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    arrows: false,
    dots: true,
    fade: false,
  };

  const renderExclusiveCard = ({ title, desc, list }) => {
    return (
      <div
        className="footer-toystory__exclusive__card"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="1000"
      >
        <Slider {...exclusiveSetting} className="footer-toystory__exclusive__list">
          {list.map((img, index) => (
            <li key={`${title}-${index + 1}`}>
              <img
                alt={title}
                className="footer-toystory__exclusive__img"
                src={`${baseImgUrl}/exclusive/${img}`}
              />
            </li>
          ))}
        </Slider>

        {title === 'Woody Set' && <div className="footer-toystory__exclusive__card--start-icon" />}

        <h3 className="footer-toystory__exclusive__card__title">{title}</h3>
        <p className="footer-toystory__exclusive__card__desc">{desc}</p>
      </div>
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.querySelector('.base-toystory')?.offsetHeight || 0;

      if (scrollTop + windowHeight >= documentHeight) {
        setPosition('static');
      } else {
        setPosition('fixed');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Fragment>
      <section className="footer-toystory__exclusive">
        <div className="footer-toystory__exclusive__bg">
          <div className="footer-toystory__exclusive__container">
            <h2 className="base-toystory__title" data-aos="fade-up" data-aos-duration="1000">
              {EXCLUSIVE.title}
            </h2>
            <p
              className="footer-toystory__exclusive__desc"
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="1000"
            >
              {EXCLUSIVE.desc}
            </p>

            <div className="footer-toystory__exclusive__content">
              {renderExclusiveCard(EXCLUSIVE.woody)}
              {renderExclusiveCard(EXCLUSIVE.buzz)}
            </div>

            <div
              className="footer-toystory__exclusive__buttons"
              data-aos="fade-up"
              data-aos-delay="900"
              data-aos-duration="1000"
            >
              <a className="base-toystory__btn--primary" href={ALL_ITEMS_LINK}>
                <span>ALL ITEMS</span>
              </a>
              <a className="base-toystory__btn--primary" href={STORES_LINK}>
                <span>
                  NEAREST <br />
                  OWNDAYS STORES
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="footer-toystory__share">
        <div className="base-toystory__container footer-toystory__share__container">
          <ul className="footer-toystory__share__list">
            {SHARES.list.map((text, index) => (
              <li key={`share-${index}`}>{text}</li>
            ))}
          </ul>

          <div className="footer-toystory__share__socials__layout">
            <h2 className="base-toystory__title">SHARE</h2>

            <ul className="footer-toystory__share__socials__icons">
              {SHARES.socials.map(({ link, className }, index) => (
                <li key={index}>
                  <a href={link} rel="noopener noreferrer" target="_blank">
                    <i aria-hidden="true" className={`fab ${className}`}></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <img
            alt="copyright-Disney/Pixar"
            className="footer-toystory__share__socials__copyright"
            loading="lazy"
            src={`${baseImgUrl}/share/copyright.svg`}
          />
        </div>

        <img
          alt="TOY STORY | OWNDAYS"
          className="footer-toystory__share__footer"
          loading="lazy"
          src={`${baseImgUrl}/share/footer.svg`}
        />
      </section>

      <section className="footer-toystory__navs-sticky">
        <div
          className="footer-toystory__navs-sticky__inner"
          style={{
            position,
          }}
        >
          <div className="base-toystory__container">
            <div className="footer-toystory__navs-sticky__actions">
              <a
                className="base-toystory__btn--primary base-toystory__hide--sp"
                href={ALL_ITEMS_LINK}
              >
                <span>ALL ITEMS</span>
              </a>

              <a className="base-toystory__btn--primary base-toystory__hide--sp" href={STORES_LINK}>
                <span>
                  NEAREST <br />
                  OWNDAYS STORES
                </span>
              </a>

              <div className="base-toystory__hide--pc">
                <a className="base-toystory__btn--primary" href={ALL_ITEMS_LINK}>
                  <span>ALL ITEMS</span>
                </a>

                <a className="base-toystory__btn--secondary" href={STORES_LINK}>
                  <span>
                    NEAREST <br />
                    OWNDAYS STORES
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
